import { i18nextLocal } from 'app/locales';
import { useTranslation } from 'react-i18next';

import type { UseTranslationOptions } from 'react-i18next';

const useTranslationLocal = (ns?: string[] | string, options: UseTranslationOptions<never> = {}) =>
  useTranslation(ns, {
    i18n: i18nextLocal,
    ...options,
  });

export { useTranslationLocal };
